// extracted by mini-css-extract-plugin
export default {"row":"document-file-status_row__6r6sj","lockIcon":"document-file-status_lockIcon__Lbadc"};